module.exports = "/images/discover-4.png";